var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 -46.198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 51.198)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.728,57.97l-6.5-6.5a.929.929,0,0,0-1.585.657v2.786h-6.5a.929.929,0,1,0,0,1.857h7.429a.929.929,0,0,0,.929-.929V54.368l4.259,4.258L19.5,62.885V61.412a.929.929,0,0,0-.929-.929H8.357V57.7a.929.929,0,0,0-1.585-.657l-6.5,6.5a.929.929,0,0,0,0,1.313l6.5,6.5a.929.929,0,0,0,.657.272.917.917,0,0,0,.356-.071.929.929,0,0,0,.573-.858V67.913h6.5a.929.929,0,0,0,0-1.857H7.428a.929.929,0,0,0-.929.929v1.473L2.241,64.2,6.5,59.94v1.473a.929.929,0,0,0,.929.929H17.643v2.786a.929.929,0,0,0,1.585.657l6.5-6.5A.929.929,0,0,0,25.728,57.97Z",
    transform: "translate(0 -51.198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.729d5e79cdb8682cb1cef8335ce0ebd2.svg";
export { ForwardRef as ReactComponent };